import pciRuntimeStateActions from '../actions/PciRuntimeStateActions';

export default function pciRuntimeStateReducer(state = {}, action) {
    switch (action.type) {
    case pciRuntimeStateActions.types.PCI_RUNTIME_STATE_SET:
        if (!action.interactionUID) {
            return state;
        }
        return {
            ...state,
            [action.interactionUID]: action.data,
        };

    case pciRuntimeStateActions.types.PCI_RUNTIME_STATE_REMOVE: {
        if (!action.interactionUID || !state[action.interactionUID]) {
            return state;
        }
        // eslint-disable-next-line no-unused-vars
        const { [action.interactionUID]: removedValue, ...rest } = state;
        return rest;
    }

    case pciRuntimeStateActions.types.PCI_RUNTIME_STATE_RESET:
        return {};

    default:
        return state;
    }
}
